const getFormatDate = (date) => {
  return `${new Date(date).getFullYear()}-${
    new Date(date).getMonth() + 1
  }-${new Date(date).getDate()}`;
};

/**
 * Generic date sort comparator that can be reused in any table column.
 * Accepts any value that the JS Date constructor can parse (string, number, Date).
 * Returns negative/zero/positive as required by Array.sort / MUI DataGrid sortComparator.
 */
const dateSortComparator = (a, b) => {
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const da = a instanceof Date ? a : new Date(a);
  const db = b instanceof Date ? b : new Date(b);

  const timeA = da.getTime();
  const timeB = db.getTime();

  if (Number.isNaN(timeA) && Number.isNaN(timeB)) return 0;
  if (Number.isNaN(timeA)) return -1;
  if (Number.isNaN(timeB)) return 1;

  return timeA - timeB;
};

export { getFormatDate, dateSortComparator };
